import React from 'react';
import MuiFormControl, { FormControlProps as MuiFormControlProps } from '@mui/material/FormControl';

/**
 * Design System FormControl
 * Adds support for color and background variants.
 */
export interface FormControlProps extends MuiFormControlProps {
  colorVariant?: string;
  backgroundVariant?: string;
}

const DSFormControl = React.forwardRef<HTMLDivElement, FormControlProps>(
  function DSFormControl(
    { colorVariant = 'default', backgroundVariant = 'default', className = '', ...props },
    ref
  ) {
    // Map color/background variants to classNames or MUI props as needed
    let variantClass = '';
    if (colorVariant === 'white' && backgroundVariant === 'transparent') {
      variantClass = 'ds-formcontrol-white-transparent';
    }
    // Add more variants as needed
    return (
      <MuiFormControl ref={ref} className={`${variantClass} ${className}`} {...props} />
    );
  }
);

export default DSFormControl;
